import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../../services/Auth/loginService';
import ReusableForm from '../../components/ReusableForm';
import projectLogo from '../../public/Logo.png';
import '../styles/FormPageStyles.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    identificador: '', // Puede ser número de documento o email
    contrasena: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!formData.identificador || !formData.contrasena) {
      setError('El número de documento/email y la contraseña son obligatorios.');
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await loginUser({ 
        identificador: formData.identificador, 
        contrasena: formData.contrasena 
      });

      if (result.success) {
        setSuccessMessage('¡Inicio de sesión exitoso! Redirigiendo...');
        navigate('/home'); 
      } else {
        setError(result.message || 'Error al iniciar sesión. Verifique sus credenciales.');
      }
    } catch (err) {
      setError('Error al procesar el inicio de sesión. Verifique la consola.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const afterButtonLinks = (
    <div className="login-page-links-container"> 
      <div className="form-link-item">
        <p>
          <Link to="/auth/forgot-password" className="form-link">¿Olvidaste tu contraseña?</Link> {/* Ruta simulada */} 
        </p>
      </div>
    </div>
  );

  return (
    <ReusableForm
      title="Iniciar Sesión"
      imageSrc={projectLogo}
      error={error}
      successMessage={successMessage}
      handleSubmit={handleSubmit}
      submitButtonText={isSubmitting ? 'Ingresando...' : 'Ingresar'}
      submitButtonDisabled={isSubmitting}
      afterButtonContent={afterButtonLinks}
    >
      <div className="form-group">
        <input 
          type="text" 
          id="identificador" 
          name="identificador" 
          placeholder="Número de documento o Email" 
          value={formData.identificador} 
          onChange={handleChange} 
          required 
        />
      </div>

      <div className="form-group">
        <input 
          type="password" 
          id="contrasena" 
          name="contrasena" 
          placeholder="Contraseña" 
          value={formData.contrasena} 
          onChange={handleChange} 
          required 
        />
      </div>
    </ReusableForm>
  );
};

export default LoginPage; 